import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";
import { getFaro } from "@/observability/faro";

async function sha256Hex(input: string): Promise<string> {
    const bytes = new TextEncoder().encode(input);
    const digest = await crypto.subtle.digest("SHA-256", bytes);
    return Array.from(new Uint8Array(digest))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}

export function useFaroUser() {
    const { userInfo } = useAuth();

    useEffect(() => {
        const faro = getFaro();
        if (!faro) return;

        if (!userInfo || !userInfo.email) {
            faro.api.resetUser();
            return;
        }

        let cancelled = false;
        void sha256Hex(userInfo.email.toLowerCase()).then((id) => {
            if (cancelled) return;
            faro.api.setUser({
                id,
                attributes: {
                    role: (userInfo.roles ?? [])[0] ?? "none",
                },
            });
        });

        return () => {
            cancelled = true;
        };
    }, [userInfo]);
}
